import { useTranslation } from "react-i18next";
import type { Partner } from "../api";
import NoData from "@/components/common/NoData.tsx";
import IconShoppingCart from "@/assets/icons/shopping-cart.svg?react";
import PartnerCard from "./PartnerCard.tsx";
import PartnerCardSkeleton from "./PartnerCardSkeleton.tsx";

interface PartnerListProps {
  partners: Partner[];
  isLoading: boolean;
}

export default function PartnerList({ partners, isLoading }: PartnerListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="grid gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <PartnerCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (partners.length === 0) {
    return (
      <div className="flex-1 flex-center">
        <NoData
          image={<IconShoppingCart className="size-12 text-gray-1" />}
          title={t("no_partners")}
          description={t("no_partners_description")}
        />
      </div>
    );
  }

  return (
    <div className="grid gap-3">
      {partners.map((partner) => (
        <PartnerCard key={partner.id} partner={partner} />
      ))}
    </div>
  );
}
